module.exports = __webpack_public_path__ + "img/fruit-gooseberries-190x100.66aec2a3.jpg";